import React, { useEffect } from "react";
import '../Assets/Css/home.css'
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { FaArrowRight, FaCheckCircle } from 'react-icons/fa';
import {
  FaShoppingCart,
  FaIndustry,
  FaFileSignature,
  FaGavel,
  FaHandshake,
  FaBalanceScale,
  FaBalanceScaleRight,
  FaFileContract,
  FaUsersCog,
  FaTruckLoading,
  FaShip,
  FaShieldAlt,
  FaMoneyBillWave,
  FaLightbulb,
  FaBoxes,
  FaGlobe,
  FaPiggyBank,
  FaCogs,
  FaExchangeAlt,
} from 'react-icons/fa';


import Banner1 from '../Assets/Images/Globalmarket.avif';
import Banner2 from '../Assets/Images/mainimport.png';
import Banner4 from '../Assets/Images/leaglelicences.avif';

import Aboutbanner from '../Assets/Images/Aboutbanner1.avif'
import Banner3 from '../Assets/Images/manufacturing.avif';

import prod1 from '../Assets/Images/HydratedLimePowder.jpg'
import prod2 from "../Assets/Images/QuicklimeIndustrialGrade.jpg"
import prod3 from "../Assets/Images/IndustrialGradeHydrochloricacid.jpg"
import prod4 from "../Assets/Images/Technicalgradeurea.jpg"
import prod5 from "../Assets/Images/ElectricalandGoodsElectronic .jpg"
import prod6 from "../Assets/Images/SoilandFertilizers.jpg"
import prod7 from "../Assets/Images/Inorganicchemicals.jpg"
import prod8 from "../Assets/Images/organicchemicals.jpg"
import prod9 from "../Assets/Images/Clothesandcosmetics.jpg"
import prod10 from "../Assets/Images/CustomizeStationary.jpg"

import mainhome from '../Assets/Images/mainbackhome.jpg'

import { Helmet } from "react-helmet";



export default function HomePage() {

  const products = [
    {
      title: "Industrial Grade Hydrated Lime Powder, 70 to 90%",
      brand: "SIDDHI INTERNATIONAL",
      description: "Industrial Grade Hydrated Lime Powder (70% to 90%)\nHydrated Lime / Calcium Hydroxide (traditionally called slaked lime) is an inorganic compound with the chemical formula Ca(OH)2. \nHydrated Lime Powder, commonly known as slaked lime, is a fine, dry powder manufactured by treating quicklime with water. It is used in a variety of industrial applications such as water treatment, soil stabilization, construction, and chemical processing.",
      image: prod1,
    },
    {
      title: "Quicklime Industrial Grade 70 to 90%",
      description: "Quicklime is a white, caustic, alkaline crystalline solid produced by heating limestone in a kiln. It is highly reactive with water and used extensively in metallurgy, environmental, and chemical industries.",
      image: prod2,
    },
    {
      title: "Industrial Grade (HCL) Hydrochloric acid 30-32%",
      description: "Hydrochloric acid is a clear, colorless solution with a strong pungent odor, widely used in chemical processing, pH regulation, and cleaning applications. Industrial grade HCl is suitable for manufacturing and treatment processes.",
      image: prod3,
    },
    {
      title: "Technical grade urea 46% for industrial use only",
      description: "Technical grade urea is a high-nitrogen compound primarily used in industrial applications like resin manufacturing, de-icing agents, and as a component in certain adhesives",
      image: prod4,
    },
    {
      title: "Electrical and Goods Electronic",
      description: "We export a wide range of electrical and electronic goods, from consumer electronics to industrial electrical components. All products meet international safety and quality standards",
      image: prod5,
    },
    {
      title: "Soil and Fertilizers",
      description: "FERTILIZERS – Natural Verses Synthetic\nWe supply a wide variety of soil conditioners and fertilizers to support sustainable agriculture",
      image: prod6,
    },
    {
      title: "Inorganic chemicals",
      description: "A diverse range of inorganic chemicals used in industrial, laboratory, and agricultural applications.",
      image: prod7,
    },
    {
      title: "Organic Chemicals",
      description: "A comprehensive supply of high-purity organic chemicals for pharmaceutical, agricultural, and industrial use.",
      image: prod8,
    },
    {
      title: "Clothes and cosmetics",
      description: "We trade in quality garments and cosmetics that meet global fashion and skincare standards.",
      image: prod9,
    },
    {
      title: "Customize Stationary as per clients requirements",
      description: "We provide customized stationery solutions including notebooks, letterheads, business cards, and more tailored to client needs.",
      image: prod10,
    },
  ];




  const services = [
    {
      title: 'B2B, B2C, and C2C',
      description: 'E-commerce encompasses transactions between businesses, businesses and consumers, and consumers themselves.',
      icon: <FaShoppingCart />,
    },
    {
      title: 'Legal and licensing services',
      description: 'Legal and licensing services involve obtaining necessary permits and complying with regulations to operate a business or engage in specific activities legally.',
      icon: <FaBalanceScale />,
    },
    {
      title: 'Industrial Licensing',
      description: '◾Industrial Licensing',
      icon: <FaIndustry />,
    },
    {
      title: 'Business Registration & Licenses',
      description: '◾Business Registration & Licenses',
      icon: <FaFileSignature />,
    },
    {
      title: 'Legal Representation',
      description: '◾Legal Representation',
      icon: <FaGavel />,
    },
    {
      title: 'Contract Review and Negotiation',
      description: '◾Contract Review and Negotiation',
      icon: <FaHandshake />,
    },
    {
      title: 'Importance of Legal and Licensing Services',
      description: '◾Importance of Legal and Licensing Services',
      icon: <FaBalanceScaleRight />,
    },
    {
      title: 'Legal Compliance',
      description: '◾Legal Compliance',
      icon: <FaFileContract />,
    },
    {
      title: 'Labour law services',
      description: '◾ Labour law services',
      icon: <FaUsersCog />,
    },
    {
      title: 'Customs Clearance',
      description: 'This involves managing the paperwork and procedures required to legally move goods into or out of a country.',
      icon: <FaTruckLoading />,
    },
    {
      title: 'Freight Forwarding',
      description: 'This includes arranging the transportation of goods by sea, air, or land, often involving the use of logistics companies.',
      icon: <FaShip />,
    },
    {
      title: 'Insurance',
      description: 'Protecting goods during transit and handling any potential losses or damage.',
      icon: <FaShieldAlt />,
    },

  ];


  return (
    <>

      <div className="mainnav min-vh-100 bg-light">

        <Helmet>
          <title>SIDDHI INTERNATIONAL | Global Trade, Manufacturing & Compliance</title>
          <meta
            name="description"
            content="SIDDHI INTERNATIONAL is your global partner in import-export, manufacturing, and legal compliance solutions. Trusted by businesses worldwide for seamless trade services."
          />
          <meta
            name="keywords"
            content="Import Export, Trade Solutions, Manufacturing, Legal Licensing, Compliance Services, Industrial Chemicals, Agro Products, Electronics, Siddhi International"
          />
          <meta name="author" content="SIDDHI INTERNATIONAL" />

          {/* Open Graph / Facebook */}
          <meta property="og:title" content="SIDDHI INTERNATIONAL" />
          <meta property="og:description" content="Empowering global trade with import-export, manufacturing, and legal services." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://siddhinternational.com" />
          <meta property="og:image" content="https://siddhinternational.com/logo.png" />

          {/* Twitter */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="SIDDHI INTERNATIONAL" />
          <meta name="twitter:description" content="Connecting Global Markets with Seamless Trade Solutions" />
          <meta name="twitter:image" content="https://siddhinternational.com/logo.png" />

          <link rel="canonical" href="https://siddhinternational.com" />
        </Helmet>

        <div className="rich-banner">
        
          <img src={mainhome} alt="Welcome to SIDDHI INTERNATIONAL" className="img-fluid richbanner-img" />
          <div className="row justify-content-center">
            <div className="col-md-4 caption text-center">

              <h1 className="fw-bold " >
                Welcome to <br />
                <span className="maincompny">
                  SIDDHI
                  INTERNATIONAL
                </span>
              </h1>
              <p>Your global partner in trade, manufacturing & compliance solutions.</p>
            </div>
          </div>
        </div>
        


        <Container className="rich-info-section mt-2 mb-2 py-4 px-4">
          <Row className="text-center m-0">
            <Col>

              <h2 className="text1 fw-bold ">
                <span className="typed-text">Connecting Global Markets with Seamless Trade Solutions</span>
              </h2>


              <p className="text-dark fw-bold lead  mt-3 fade-in-delay">
                Empowering businesses worldwide through reliable import-export services.
              </p>
              <p className="  fade-in-delay-2">
                Your trusted partner in navigating international trade complexities with efficiency and integrity.
              </p>
            </Col>
          </Row>
        </Container>

        <div className="bg-body-secondary p-4">
          <Container className='mb-4 ' >
            <Row className="text-center m-0">
              <Col>

                <Row>
                  <Col lg={6} className="mb-2">
                    <Row className="justify-content-center">
                      <Col lg={10} className="mb-3">
                        <img src={Aboutbanner} alt="" style={{ width: '100%', height: '200px', borderRadius: '8px' }} />
                      </Col>
                    </Row>
                    <Row className="justify-content-center g-3">
                      <Col lg={5}>
                        <img src={Banner3} alt=""
                          style={{ width: '100%', height: '200px', borderRadius: '8px' }} />
                      </Col>
                      <Col lg={5}>
                        <img src={Banner4} alt=""
                          style={{ width: '100%', height: '200px', borderRadius: '8px' }} />
                      </Col>
                    </Row>
                  </Col>


                  <Col lg={6}>
                    <h3 className="Mainhead">About Us</h3>
                    <p style={{ textAlign: 'justify' }}>
                      <b style={{ color: '#29AAE1' }}>M/s. SIDDHI INTERNATIONAL </b> is a fast-growing Indian enterprise engaged in Import & Export, Manufacturing, Distribution, and Legal & Licensing Consultation. Established in 2024, we specialize in chemicals, electronics, agro products, ecommerce trading, and compliance services, with a commitment to quality, trust, and guarantee.
                    </p>
                    <p style={{ textAlign: 'justify' }}>
                      With over 20+ years of experience, founder  <b style={{ color: '#29AAE1' }}> Gajanan Mohite </b>  has worked with top names in the export-import industry. Our transparent, ethical, and customer-focused approach helps businesses connect globally and grow seamlessly.
                      
                    </p>

                    <Button
                      href="/aboutus"
                      className="gradientabout-button  rounded-pill"
                    >
                      More <FaArrowRight />
                    </Button>

                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Core Values Section */}

        <Container className="mb-4 py-4">
          <Row className="text-center mb-2 m-0">
            <Col>
              <h3 className="Mainhead">Our Products </h3>
              <p className="fw-medium text-muted">
                Explore our diversified portfolio in trading, manufacturing, licensing & more:
              </p>
            </Col>
          </Row>

          {/* Products Section */}
          <Row className="mb-2 m-0">
            <Col md={12}>
              <Card className="border-0 bg-transparent">
                <Card.Body>
                  <Row className="g-3 justify-content-center">
                    {products.map((product, index) => (
                      <Col md={2} sm={4} xs={6} className="viewformob" key={index}>
                        <Card className="product-card glass-effect text-center h-100 border-0">
                          <div className="product-image-wrapper">
                            <img
                              src={product.image}
                              alt={product.title}
                              className="product-image"
                            />
                          </div>
                          <Card.Body>
                            <Card.Title className="fw-semibold fs-6 product-title">
                              {product.title}
                            </Card.Title>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>


          {/* More Button */}
          <Row className="text-center m-0">
            <Col>
              <Button
                href="/products"
                className="gradient-button px-4 py-2 rounded-pill"
              >
                More <FaArrowRight />
              </Button>
            </Col>
          </Row>

        </Container>

        {/* Call to Action */}
        <section className="cta-section mt-4 mb-4 text-center py-5">
          <Container>
            <h4 className='mb-4'>
              Ready to grow? At  SIDDHI INTERNATIONAL, we provide trust, growth, and global business opportunities. <strong>Contact us today!</strong></h4>
            <Button href="/contact" className="contact-submit-btn" >Get in Touch</Button>
          </Container>
        </section>

        <div className="mb-4">
          <Container>
            <h3 className="Mainhead mb-4">Services We Offer</h3>
            <Row className="gx-5 gy-4 m-0">
              {services.map((service, index) => (
                <Col key={index} md={3}>
                  <div className="service-line d-flex align-items-start gap-3">

                    <div className="icon-box">{service.icon}</div>
                    <div>
                      <h6 className="mb-1 fw-semibold text-dark">{service.title}</h6>

                    </div>
                  </div>
                </Col>
              ))}
            </Row>
            <Row className="text-center mt-4 m-0">
              <Col>
                <Button
                  href="/products"
                  className="gradient-button px-4 py-2 rounded-pill"
                >
                  More <FaArrowRight />
                </Button>
              </Col>
            </Row>

          </Container>
        </div>

      </div>


    </>
  )
}
